import React from 'react';
import { cn } from '~/lib/utils';
import { CallLogDurationProps } from './types';
import { formatStartTime, formatDuration } from './utils/formatCallLogDuration';

export const CallLogDuration: React.FC<CallLogDurationProps> = ({
  answeredAt, endedAt, startedAt, direction, disposition, category,
}) => (
  <div
    data-testid="call-log-duration"
    className={cn(
      'pl-[67px] text-left text-[13px] leading-[21px] font-normal text-secondary self-end',
      { 'text-destructive': category === 'missed' }
    )}
  >
    {formatStartTime(startedAt)} {formatDuration(answeredAt, endedAt, direction, disposition)}
  </div>
);